(()=>{'use strict';
const PDFJS='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
const WORKER='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
const q=(s,r=document)=>r.querySelector(s), qa=(s,r=document)=>[...r.querySelectorAll(s)];
let libPromise=null;
function loadLib(){
  if(window.pdfjsLib){window.pdfjsLib.GlobalWorkerOptions.workerSrc=WORKER;return Promise.resolve(window.pdfjsLib)}
  if(libPromise)return libPromise;
  libPromise=new Promise((resolve,reject)=>{
    const s=document.createElement('script');s.src=PDFJS;s.async=true;s.crossOrigin='anonymous';
    s.onload=()=>{if(!window.pdfjsLib)return reject(new Error('PDF.js non chargé'));window.pdfjsLib.GlobalWorkerOptions.workerSrc=WORKER;resolve(window.pdfjsLib)};
    s.onerror=()=>reject(new Error('Impossible de charger le lecteur PDF'));
    document.head.appendChild(s);
  });
  return libPromise;
}
function isPdf(v,frame){
  const src=frame?.src||frame?.getAttribute('src')||'';
  const meta=(q('footer',v)?.textContent||'')+' '+(q('header',v)?.textContent||'');
  return /\.pdf(?:$|[?#])/i.test(src)||/\bPDF\b/i.test(meta);
}
async function renderPage(pdf,num,slot,scroll){
  if(slot.dataset.rendered||slot.dataset.rendering)return;
  slot.dataset.rendering='1';
  try{
    const page=await pdf.getPage(num);
    const base=page.getViewport({scale:1});
    const usable=Math.max(280,(scroll.clientWidth||700)-28);
    const cssScale=Math.min(2,usable/base.width);
    const dpr=Math.min(2,window.devicePixelRatio||1);
    const viewport=page.getViewport({scale:cssScale*dpr});
    const canvas=document.createElement('canvas');
    canvas.width=Math.floor(viewport.width);canvas.height=Math.floor(viewport.height);
    canvas.style.width=Math.floor(viewport.width/dpr)+'px';canvas.style.height=Math.floor(viewport.height/dpr)+'px';
    canvas.setAttribute('aria-label','Page '+num);
    slot.innerHTML='';slot.appendChild(canvas);
    await page.render({canvasContext:canvas.getContext('2d',{alpha:false}),viewport}).promise;
    slot.dataset.rendered='1';
  }catch(e){slot.innerHTML='<div class="v277-pdf-error">Impossible de rendre la page '+num+'.</div>'}
  finally{delete slot.dataset.rendering}
}
async function upgrade(v){
  if(v.dataset.v277)return;
  const frame=q('iframe',v), main=q('main',v); if(!frame||!main||!isPdf(v,frame))return;
  v.dataset.v277='loading';v.classList.add('v277-pdfjs-viewer');
  const url=frame.src;
  const holder=document.createElement('div');holder.className='v277-pdf-loading';holder.innerHTML='<b>CHARGEMENT DU PDF COMPLET…</b><span>Préparation de toutes les pages</span>';
  frame.replaceWith(holder);
  try{
    const pdfjs=await loadLib();
    const loading=pdfjs.getDocument({url,withCredentials:false});
    const pdf=await loading.promise;
    const pages=document.createElement('div');pages.className='v277-pdf-pages';pages.dataset.pages=pdf.numPages;
    const status=document.createElement('div');status.className='v277-page-status';status.textContent='PAGE 1 / '+pdf.numPages;
    main.appendChild(status);
    holder.replaceWith(pages);
    const slots=[];
    for(let i=1;i<=pdf.numPages;i++){
      const page=await pdf.getPage(i); const vp=page.getViewport({scale:1});
      const slot=document.createElement('section');slot.className='v277-pdf-page';slot.dataset.page=String(i);
      slot.style.aspectRatio=vp.width+' / '+vp.height;
      slot.innerHTML='<span>PAGE '+i+'</span>'; pages.appendChild(slot);slots.push(slot);
    }
    const pageObserver=new IntersectionObserver(entries=>{
      entries.filter(x=>x.isIntersecting).forEach(x=>renderPage(pdf,Number(x.target.dataset.page),x.target,main));
    },{root:main,rootMargin:'900px 0px',threshold:.01});
    slots.forEach(s=>pageObserver.observe(s));
    const currentObserver=new IntersectionObserver(entries=>{
      const visible=entries.filter(x=>x.isIntersecting).sort((a,b)=>b.intersectionRatio-a.intersectionRatio)[0];
      if(visible)status.textContent='PAGE '+visible.target.dataset.page+' / '+pdf.numPages;
    },{root:main,threshold:[.25,.5,.75]});
    slots.forEach(s=>currentObserver.observe(s));
    renderPage(pdf,1,slots[0],main);
    v.dataset.v277='ready';
    const oldHint=q('.v276-pdf-hint',v);if(oldHint)oldHint.remove();
    const a=q('footer a',v);if(a)a.textContent='OUVRIR LE PDF ORIGINAL ↗';
  }catch(err){
    console.warn('[Seven V277 PDF]',err);
    holder.className='v277-pdf-fallback';
    holder.innerHTML='<b>Le lecteur intégré n’a pas pu charger toutes les pages.</b><span>Utilise « Ouvrir le PDF original » pour afficher le document complet.</span>';
    v.dataset.v277='fallback';
  }
}
function scan(){qa('[data-v269-viewer],[data-v294-viewer]').forEach(upgrade)}
new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('seven:resource-open',()=>setTimeout(scan,30));
scan();
})();
